import { LICENSE_FIELDS } from '../../../../../config/constants'
import type { FormValues } from '../../../../../ui/Form'
import { convertFormValueToString } from '../../../../../utils/common'

import type { DraftLicense } from './CreateLicense.types'

export const mapFormValuesToDraftLicense = (
  formValues: FormValues
): DraftLicense => {
  const {
    [LICENSE_FIELDS.PACKAGE]: name,
    [LICENSE_FIELDS.START_DATE]: startDate,
    [LICENSE_FIELDS.END_DATE]: endDate,
    [LICENSE_FIELDS.REVOKE_OLD_LICENSE]: revokeOldLicense,
  } = formValues

  return {
    package: convertFormValueToString(name),
    startDate: startDate ? convertFormValueToString(startDate) : '',
    endDate: endDate ? convertFormValueToString(endDate) : null,
    revokeOldLicense: revokeOldLicense === true,
  }
}
